import type { ButtonProps } from 'antd';
import { Button } from 'antd';
import {
  orgActionButtonStyle,
  orgPrimaryActionButtonClassName,
  orgPrimaryButtonStyle,
} from './organisationsUi';

export function OrgPrimaryButton({ className, style, ...props }: ButtonProps) {
  return (
    <Button
      type="primary"
      size="large"
      className={[orgPrimaryActionButtonClassName, className].filter(Boolean).join(' ')}
      {...props}
      style={{ ...orgPrimaryButtonStyle, ...orgActionButtonStyle, ...style }}
    />
  );
}
